import { createContext, ReactNode, useContext } from "react";

import { useFilterDashboard } from "./filter-dashboard.hook";

const FilterDashboardContext = createContext(
  {} as ReturnType<typeof useFilterDashboard>
);
export function useFilterDashboardContext() {
  return useContext(FilterDashboardContext);
}

interface FilterDashboardProviderProps {
  children: ReactNode;
}
export function FilterDashboardProvider({
  children,
}: FilterDashboardProviderProps) {
  return (
    <FilterDashboardContext.Provider value={useFilterDashboard()}>
      {children}
    </FilterDashboardContext.Provider>
  );
}
